import { Box, Stack } from '@ads-core/components';
import {
  ComponentParams,
  ComponentRendering,
  Placeholder,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { useSitecoreContext } from '@liander/context';

export interface CongestionReportsDetailContainerProps {
  rendering: ComponentRendering;
  params?: ComponentParams;
}

const CongestionReportsDetailContainer = (props: CongestionReportsDetailContainerProps) => {
  const { isEditor } = useSitecoreContext();

  return (
    <Box
      padding={isEditor ? 4 : 0}
      style={isEditor ? { border: '1px dotted black' } : undefined}
      asChild
    >
      <Stack direction="column" gap={20}>
        <Placeholder
          name="congestion-reports-detail-container-content"
          rendering={props.rendering}
        />
      </Stack>
    </Box>
  );
};

export default CongestionReportsDetailContainer;
